export const SELECTED_SIZE_REPLACEMENT_INDICATOR = '{selected_size}';
export const BEDDING_SIZE_NAME = 'bedding-size';
export const PILLOW_SIZE_NAME = 'pillow-size';
export const SIZE_NAME = 'size';
